export default "__VITE_ASSET__N6A33gdW__"